import { Component, OnInit } from '@angular/core';
import {ConfirmationService, MessageService} from "primeng/api";
import {NetworkService} from "../../services/network.service";
import {Router} from "@angular/router";
import {URL_BASE, qtdLinhas, getUrlCad} from "../../controller/staticValues";
import {DadosDefaultService} from "../../services/dados-default.service";

@Component({
    selector: 'app-cidades',
    templateUrl: './cidades.component.html',
    styleUrls: ['./cidades.component.css'],
    standalone: false
})
export class CidadesComponent implements OnInit {

    public first: number = 0
    public top: number = qtdLinhas()
    qtdLinhas = qtdLinhas();
    public totalItens: number = 0
    public lista: any[] = []
    public dadosFixos: any[] = []
    filtro = '';

    opcoesTable = [
        {label: 'Editar', icon: 'fa fa-plus', command: (e: any) => {
            this.router.navigate([`editar-cidades/${e.Id}`])
        }},
        {label: 'Incluir', icon: 'fa fa-plus', command: (e: any) => {
            this.router.navigate(['incluir-cidades'])
        }},
    ]

    constructor(private networkService: NetworkService, private router: Router, private messageService: MessageService, private dadosDefaultService: DadosDefaultService) {

    }

    ngOnInit() {
        this.networkService.listar(getUrlCad(), 'cidades', 0, 7, 'Cidade', 'asc', '', '').subscribe((v: any) => {
            this.lista = v.value
            this.dadosFixos = v.value
            this.totalItens = v.length
        }).add(() => this.networkService.exibirLoader.next(false))
    }

    get usuarios() {
        return this.lista.filter(v => {
            if (v.Cidade === null) {
                v.Cidade = ''
            }
            return  v.Cidade.toLowerCase().includes(this.filtro.toLowerCase())
        })
    }

    incluir(){
        this.router.navigate(['incluir-cidades'])
    }
}
